var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.option)?_c('div',[_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.option.Name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }